import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

// @material-ui/core components
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Button, TextField } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

// core services
import { getApi } from '../../api';

// core components
import RowUser from './RowUser';

const roles = [
  {
    value: 'admin',
    label: 'Administrador',
  },
  {
    value: 'programmer',
    label: 'Programador',
  },
  {
    value: 'driver',
    label: 'Chofer',
  },
  {
    value: 'collaborator',
    label: 'Colaborador',
  },
];

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      marginTop: '0px',
      overflowX: 'auto',
    },
    table: {
      minWidth: 650,
    },
    button: {
      marginRight: 10
    }
  }),
);

async function getUsers() {
  try {
    //* *Make post user */
    const response = await getApi().get('/users', { data: {} });

    return response;
  } catch (e) {
    // console.log("e:");
    // console.log(e.status);
  }
}

// async function deleteUser(userID) {
//   try {
//     const response = await getApi().delete(`/users/${userID}`, { data: {} });

//     return response;
//   } catch (error) {
//     return error;
//   }
// }

export default function Users() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [users, setUsers] = useState({
    isLoading: true,
    list: [],
  });

  const [newUser, setNewUser] = useState({
    isNew: false,
    first_name: '',
    last_name: '',
    email: '',
    role: 'collaborator',
    username: null,
  });

  const handleUserChange = name => event => {
    setNewUser({
      ...newUser,
      [name]: event.target.value,
    });
  };

  useEffect(() => {
    async function loadUsers() {
      try {
        if (users.isLoading) {
          const response = await getUsers();

          if (response.status === 200) {
            setUsers({
              ...users,
              isLoading: false,
              list: response.data.sort((a, b) => (a.id < b.id ? 1 : -1)),
            });
          }
        }
      } catch (error) {}
    }

    loadUsers();
  }, [users]);

  const handleSubmitUser = async () => {
    // make insert
    try {
      const user = newUser;
      const response = await getApi().post(
        '/users',
        {
          user,
        },
        '',
      );

      //* *200 authorized*/
      if (response !== undefined && response.status === 200) {
        // openClose();
        setNewUser({
          ...newUser,
          isNew: false,
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          role: 'collaborator',
          username: null,
        });
        setUsers({ ...users, isLoading: true });
        enqueueSnackbar('Usuario creado satisfactoriamente', {
          variant: 'success',
        });
      }
    } catch (error) {
      enqueueSnackbar('Ocurrió un error al insertar el usuario, por favor validar los datos', {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <p>Administrar usuarios</p>
      {newUser.isNew ? (
        <>
          <TextField
            id="outlined-full-width"
            label="Nombre"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleUserChange('first_name')}
          />
          <TextField
            id="outlined-full-width"
            label="Apellido"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleUserChange('last_name')}
          />
          <TextField
            id="outlined-full-width"
            type="email"
            label="Correo electrónico"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleUserChange('email')}
          />
          <TextField
            id="outlined-select-currency-native"
            select
            label="Rol"
            style={{ margin: 8 }}
            // className={classes.textField}
            value={newUser.role}
            onChange={handleUserChange('role')}
            SelectProps={{
              native: true,
            }}
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          >
            {roles.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        </>
      ) : (
        ''
      )}
      {newUser.isNew && (
        <Button
          variant="contained"
          className={classes.button}
          color={'primary'}
          onClick={() => {
            handleSubmitUser();
          }}
          startIcon={<CheckCircleOutlineIcon />}
        >
          Guardar
        </Button>
      )}

      <Button
        variant="contained"
        className={classes.button}
        color={!newUser.isNew ? 'primary' : 'secondary'}
        onClick={event => setNewUser({ ...newUser, isNew: !newUser.isNew })}
        startIcon={!newUser.isNew ? <AddCircleOutlineIcon /> : <CancelOutlinedIcon />}
      >
        {!newUser.isNew ? 'Nuevo usuario' : 'Cancelar'}
      </Button>
      <br />
      <br />
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Nombre</TableCell>
            <TableCell align="right">Apellidos</TableCell>
            <TableCell align="right">Identificación</TableCell>
            <TableCell align="center">No. de empleado</TableCell>
            <TableCell align="center">Correo electrónico</TableCell>
            <TableCell align="center">Tipo</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!users.isLoading
            ? users.list.map((row, index) => (
                <RowUser key={row.id} index={index} row={row} setUsers={setUsers} />
              ))
            : null}
        </TableBody>
      </Table>
    </>
  );
}
